module.exports = __webpack_public_path__ + "img/report.d7a0e42f.svg";